/**
 * Aura product page scripts — scoped to .pb-aura-product
 */
(function () {
  'use strict';

  var ROOT_SELECTOR = '.pb-aura-product';
  var booted = false;

  function initTraining(root) {
    var section = root.closest('[data-pb-aura-training]');
    if (!section || section.dataset.pbAuraTrainingInit === 'true') {
      return;
    }
    section.dataset.pbAuraTrainingInit = 'true';

    var tabs = section.querySelectorAll('[data-pb-aura-tab]');
    var panels = section.querySelectorAll('[data-pb-aura-panel]');
    if (!tabs.length || !panels.length) {
      return;
    }

    function activate(index) {
      tabs.forEach(function (tab) {
        var isActive = tab.dataset.pbAuraTab === String(index);
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
      panels.forEach(function (panel) {
        panel.classList.toggle('is-active', panel.dataset.pbAuraPanel === String(index));
      });
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        activate(tab.dataset.pbAuraTab);
      });
    });
  }

  function buildThreeSportsMediaItem(sport, mode) {
    var item = document.createElement('div');
    item.className = 'pb-aura-three-sports__media-item';
    var url = mode === 'mobile' ? sport.mobileUrl : sport.pcUrl;
    var poster = mode === 'mobile' ? sport.mobilePoster : sport.pcPoster;
    var alt = sport.alt || sport.label || '';

    if (url) {
      var video = document.createElement('video');
      video.className = 'pb-aura-three-sports__video pb-aura-three-sports__video--static';
      video.src = url;
      video.muted = true;
      video.playsInline = true;
      video.setAttribute('playsinline', '');
      video.setAttribute('preload', 'auto');
      if (poster) {
        video.poster = poster;
      }
      item.appendChild(video);
      return item;
    }

    if (poster) {
      var img = document.createElement('img');
      img.className = 'pb-aura-three-sports__poster';
      img.src = poster;
      img.alt = alt;
      img.loading = 'lazy';
      item.appendChild(img);
      return item;
    }

    var placeholder = document.createElement('div');
    placeholder.className = 'pb-aura-three-sports__placeholder';
    placeholder.setAttribute('aria-hidden', 'true');
    item.appendChild(placeholder);
    return item;
  }

  function setThreeSportsMediaPlayback(item, shouldPlay) {
    if (!item) {
      return;
    }

    var video = item.querySelector('video');
    if (!video) {
      return;
    }

    if (shouldPlay) {
      video.classList.remove('pb-aura-three-sports__video--static');
      video.loop = true;
      var playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {});
      }
      return;
    }

    video.pause();
    video.loop = false;
    video.classList.add('pb-aura-three-sports__video--static');
    try {
      video.currentTime = 0;
    } catch (error) {}
  }

  function mountThreeSportsMediaItem(container, item) {
    if (!container || !item) {
      return;
    }

    Array.prototype.slice.call(container.children).forEach(function (child) {
      if (child !== item) {
        container.removeChild(child);
      }
    });

    if (item.parentElement !== container) {
      container.appendChild(item);
    }
  }

  function initThreeSports(section) {
    if (!section || section.dataset.pbAuraThreeSportsInit === 'true') {
      return;
    }
    section.dataset.pbAuraThreeSportsInit = 'true';

    var configEl = section.querySelector('[data-pb-aura-three-sports-config]');
    if (!configEl) {
      return;
    }

    var config;
    try {
      config = JSON.parse(configEl.textContent);
    } catch (error) {
      return;
    }

    if (!config.sports || config.sports.length !== 3) {
      return;
    }

    var active = 0;
    var tabs = section.querySelectorAll('[data-pb-aura-three-sport-tab]');
    var railSlots = section.querySelectorAll('[data-pb-aura-three-sport-slot]');
    var mobileWrap = section.querySelector('[data-pb-aura-three-sport-mobile]');
    var mobileMedia = mobileWrap ? mobileWrap.querySelector('.pb-aura-three-sports__media') : null;
    var prevBtn = section.querySelector('[data-pb-aura-three-sport-prev]');
    var nextBtn = section.querySelector('[data-pb-aura-three-sport-next]');
    var indicators = section.querySelectorAll('[data-pb-aura-three-sport-indicator], [data-pb-aura-three-sport-indicator-mobile]');
    var slotOpacities = [0.5, 1, 0.5];
    var mediaCache = { pc: [], mobile: [] };
    var mobileActiveIndex = null;

    function ensureMedia(mode, sportIndex) {
      if (mediaCache[mode][sportIndex]) {
        return mediaCache[mode][sportIndex];
      }

      mediaCache[mode][sportIndex] = buildThreeSportsMediaItem(config.sports[sportIndex], mode);
      return mediaCache[mode][sportIndex];
    }

    function getRailOrder(index) {
      return [(index + 1) % 3, index, (index + 2) % 3];
    }

    function setIndicator(index) {
      indicators.forEach(function (indicator) {
        indicator.style.transform = 'translateX(' + index * 100 + '%)';
      });
    }

    function setTabs(index) {
      tabs.forEach(function (tab) {
        var isActive = tab.dataset.pbAuraThreeSportTab === String(index);
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
    }

    function updateRail(index) {
      var order = getRailOrder(index);
      var playingItem = ensureMedia('pc', order[1]);

      railSlots.forEach(function (slot, slotIndex) {
        var sportIndex = order[slotIndex];
        slot.dataset.sportIndex = String(sportIndex);
        slot.style.opacity = String(slotOpacities[slotIndex]);
        var media = slot.querySelector('.pb-aura-three-sports__media');
        mountThreeSportsMediaItem(media, ensureMedia('pc', sportIndex));
      });

      mediaCache.pc.forEach(function (item) {
        if (item) {
          setThreeSportsMediaPlayback(item, item === playingItem);
        }
      });
    }

    function updateMobile(index) {
      if (!mobileMedia) {
        return;
      }

      var playingItem = ensureMedia('mobile', index);
      var previousItem =
        mobileActiveIndex !== null && mobileActiveIndex !== index
          ? mediaCache.mobile[mobileActiveIndex]
          : null;

      if (previousItem) {
        setThreeSportsMediaPlayback(previousItem, false);
      }

      mountThreeSportsMediaItem(mobileMedia, playingItem);
      setThreeSportsMediaPlayback(playingItem, true);
      mobileActiveIndex = index;
    }

    function activate(index) {
      active = index;
      setTabs(active);
      setIndicator(active);
      updateRail(active);
      updateMobile(active);
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        activate(parseInt(tab.dataset.pbAuraThreeSportTab, 10));
      });
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        activate((active - 1 + 3) % 3);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        activate((active + 1) % 3);
      });
    }

    activate(active);
  }

  function bootThreeSports() {
    document.querySelectorAll('.pb-aura-three-sports[data-pb-aura-three-sports]').forEach(initThreeSports);
  }

  function initCustomDrills(section) {
    if (!section || section.dataset.pbAuraCustomDrillsInit === 'true') {
      return;
    }
    section.dataset.pbAuraCustomDrillsInit = 'true';

    var tabs = section.querySelectorAll('[data-pb-aura-custom-drills-tab]');
    var panels = section.querySelectorAll('[data-pb-aura-custom-drills-panel]');
    if (!tabs.length || !panels.length) {
      return;
    }

    function activate(index) {
      section.dataset.pbAuraCustomDrillsActive = String(index);

      tabs.forEach(function (tab) {
        var isActive = tab.dataset.pbAuraCustomDrillsTab === String(index);
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      panels.forEach(function (panel) {
        panel.classList.toggle('is-active', panel.dataset.pbAuraCustomDrillsPanel === String(index));
      });
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        activate(parseInt(tab.dataset.pbAuraCustomDrillsTab, 10));
      });
    });
  }

  function bootCustomDrills() {
    document.querySelectorAll('.pb-aura-custom-drills[data-pb-aura-custom-drills]').forEach(initCustomDrills);
  }

  function initFeatureVideoBlocks(section) {
    if (!section || section.dataset.pbAuraFeatureVideoBlocksInit === 'true') {
      return;
    }
    section.dataset.pbAuraFeatureVideoBlocksInit = 'true';

    section.querySelectorAll('.pb-aura-feature-video-blocks__video').forEach(function (video) {
      video.play().catch(function () {});
    });
  }

  function bootFeatureVideoBlocks() {
    document
      .querySelectorAll('.pb-aura-feature-video-blocks[data-pb-aura-feature-video-blocks]')
      .forEach(initFeatureVideoBlocks);
  }

  function initAiReport(root) {
    var section = root.closest('[data-pb-aura-ai-report]');
    if (!section || section.dataset.pbAuraAiReportInit === 'true') {
      return;
    }
    section.dataset.pbAuraAiReportInit = 'true';

    var triggers = section.querySelectorAll('[data-pb-aura-ai-trigger]');
    var items = section.querySelectorAll('[data-pb-aura-ai-item]');
    var screens = section.querySelectorAll('[data-pb-aura-ai-screen]');
    if (!triggers.length) {
      return;
    }

    function activate(index) {
      items.forEach(function (item) {
        item.classList.toggle('is-active', item.dataset.pbAuraAiItem === String(index));
      });
      screens.forEach(function (screen) {
        screen.classList.toggle('is-active', screen.dataset.pbAuraAiScreen === String(index));
      });
    }

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        activate(trigger.dataset.pbAuraAiTrigger);
      });
    });
  }

  function initPbAuraProduct(root) {
    if (!root || root.dataset.pbAuraInit === 'true') {
      return;
    }
    root.dataset.pbAuraInit = 'true';
    initTraining(root);
    initAiReport(root);
  }

  function boot() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(initPbAuraProduct);
    bootThreeSports();
    bootCustomDrills();
    bootFeatureVideoBlocks();
    booted = true;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else if (!booted) {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target) {
      return;
    }

    if (event.target.matches && event.target.matches('.pb-aura-three-sports[data-pb-aura-three-sports]')) {
      initThreeSports(event.target);
    } else if (event.target.querySelectorAll) {
      event.target.querySelectorAll('.pb-aura-three-sports[data-pb-aura-three-sports]').forEach(initThreeSports);
    }

    if (event.target.matches && event.target.matches('.pb-aura-custom-drills[data-pb-aura-custom-drills]')) {
      initCustomDrills(event.target);
    } else if (event.target.querySelectorAll) {
      event.target.querySelectorAll('.pb-aura-custom-drills[data-pb-aura-custom-drills]').forEach(initCustomDrills);
    }

    if (event.target.matches && event.target.matches('.pb-aura-feature-video-blocks[data-pb-aura-feature-video-blocks]')) {
      initFeatureVideoBlocks(event.target);
    } else if (event.target.querySelectorAll) {
      event.target
        .querySelectorAll('.pb-aura-feature-video-blocks[data-pb-aura-feature-video-blocks]')
        .forEach(initFeatureVideoBlocks);
    }

    var roots = event.target.querySelectorAll
      ? event.target.querySelectorAll(ROOT_SELECTOR)
      : [];
    roots.forEach(initPbAuraProduct);
  });
})();
